import { Layout } from "antd";
import styled, { css } from "styled-components";

export const MainContainer = styled(Layout)<{
    $paddingTop?: string;
    $paddingBottom?: string;
    $padding?: string;
}>`
    max-height: 100%;
    height: 100%;
    flex-grow: 1;
    overflow-y: auto;
    width: 100%;
    padding: 16px;
    position: relative;
    ${({ $padding }) => $padding && `padding: ${$padding};`}
    ${({ $paddingTop }) => $paddingTop && `padding-top: ${$paddingTop};`}
    ${({ $paddingBottom }) =>
        $paddingBottom && `padding-bottom: ${$paddingBottom};`}
`;

type FixedPositionProps =
    | { top: string; bottom?: never }
    | { top?: never; bottom: string };

export const FixedCenteredLayout = styled(Layout)<
    FixedPositionProps & {
        padding?: string;
        zIndex?: number;
    }
>`
    position: fixed;
    transform: translateX(-50%);
    max-width: ${({ theme }) => theme.maxContentWidth};
    padding: ${({ padding }) => padding ?? "16px"};
    z-index: ${({ zIndex }) => zIndex ?? 1000};
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
    left: 50%;

    ${({ top }) => top && `top: ${top};`}
    ${({ bottom }) => bottom && `bottom: ${bottom};`}
`;

export const MultiselectContainer = styled.div<{ $minHeight: string }>`
    ${({ $minHeight }) =>
        $minHeight
            ? css`
                  .ant-select-selector {
                      min-height: ${$minHeight};
                  }

                  .ant-select-selection-wrap {
                      align-self: center;
                  }
              `
            : null}
`;
